export default __webpack_public_path__ + "static/media/12.34631b8a.jpg";